import { getImage, GatsbyImage, withArtDirection } from "gatsby-plugin-image"
import { motion } from "framer-motion"
import { graphql } from "gatsby"
import tw, { styled } from "twin.macro"

const Title = styled(motion.h1)`
  line-height: 0.5;
  color: rgba(255, 255, 255, 0.25);
  font-size: 6rem;

  @media (min-width: 375px) {
    font-size: 7rem;
  }

  @media (min-width: 480px) {
    font-size: 8rem;
  }

  @media (min-width: 640px) {
    font-size: 9rem;
  }

  @media (min-width: 768px) {
    font-size: 12rem;
  }
  @media (min-width: 1024px) {
    font-size: 14rem;
  }
  @media (min-width: 1280px) {
    font-size: 16rem;
  }
  @media (min-width: 1440px) {
    font-size: 18rem;
  }
`

const mqs = {
  poster_2: "(min-width: 768px)",
  poster_3: "(min-width: 1280px)",
}

const HeroImageWrapper = styled.div`
  position: relative;
  padding-bottom: ${(6 / 13) * 100}%;

  @media ${mqs.poster_2} {
    padding-bottom: ${(1 / 3) * 100}%;
  }

  @media ${mqs.poster_3} {
    padding-bottom: ${(1 / 4) * 100}%;
  }
`

const HeroImage = styled(GatsbyImage)`
  ${tw`!absolute !inset-0`}
`

const HeroBanner = ({ data }) => {
  const images = withArtDirection(getImage(data.poster.localFile), [
    {
      media: mqs.poster_2,
      image: getImage(data.poster_2.localFile),
    },
    {
      media: mqs.poster_3,
      image: getImage(data.poster_3.localFile),
    },
  ])
  return (
    <div tw="relative">
      <HeroImageWrapper className="half-tone">
        <HeroImage image={images} alt={data.poster.alternativeText} />
      </HeroImageWrapper>
      {data.title && (
        <Title
          variants={{
            initial: { y: "200%" },
            enter: { y: 0, transition: { duration: 0.8 } },
          }}
          tw="font-display absolute w-full text-center uppercase bottom-0"
        >
          {data.title}
        </Title>
      )}
    </div>
  )
}

export const query = graphql`
  fragment HeroBanner on FT_ComponentMoleculesBanner {
    title
    poster: image {
      url
      alternativeText
      localFile {
        childImageSharp {
          gatsbyImageData(
            aspectRatio: 2.16666667
            layout: FULL_WIDTH
            transformOptions: { cropFocus: ENTROPY }
            formats: [AUTO, WEBP, AVIF]
          )
        }
      }
    }
    poster_2: image {
      url
      alternativeText
      localFile {
        childImageSharp {
          gatsbyImageData(
            aspectRatio: 3
            layout: FULL_WIDTH
            transformOptions: { cropFocus: ENTROPY }
            formats: [AUTO, WEBP, AVIF]
          )
        }
      }
    }
    poster_3: image {
      url
      alternativeText
      localFile {
        childImageSharp {
          gatsbyImageData(
            aspectRatio: 4
            layout: FULL_WIDTH
            transformOptions: { cropFocus: ENTROPY }
            formats: [AUTO, WEBP, AVIF]
          )
        }
      }
    }
  }
`
export default HeroBanner
